class AccordionImage {
	constructor(accordionImageEl) {
		this.el = accordionImageEl;
		this.init();
	}
	
	init() {
		this.el.querySelectorAll('.accordion-container__header').forEach( (el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				const accordionImageWrappers = this.el.querySelectorAll('[data-image="' + el.dataset.accHeading + '"]');
				this.el.querySelectorAll('.accordion-image__image-wrapper').forEach(accImageWrapper => {
					accImageWrapper.classList.remove('active');
				});
				accordionImageWrappers.forEach(imageWrapper => {
					imageWrapper.classList.add('active');	
				})
			});
		});
	}
}

export default AccordionImage;